import { Socket } from "socket.io-client";

export default class GameLobby {
  public static get socket(): Socket {
    return (window as any).lobbySocket as Socket;
  }

  public static set socket(socket: Socket) {
    (window as any).lobbySocket = socket;
  }
}
